import { BaseService, RequestType, ResponseType } from "@intech/react-service";
import { FichaFinancAssistidoEntidade } from "../entidades/FichaFinancAssistidoEntidade";
import { ContrachequeEntidade } from "../entidades/ContrachequeEntidade";

class FichaFinancAssistido extends BaseService {
	constructor() {
		super("FichaFinancAssistido");
	}

	BuscarUltimaPorProcesso = (sqProcesso: number) =>
		this.CreateRequest<Array<FichaFinancAssistidoEntidade>>(RequestType.GET, `BuscarUltimaPorProcesso/${sqProcesso}`);

	BuscarDatasPorProcesso = (sqProcesso: number) =>
		this.CreateRequest<Array<FichaFinancAssistidoEntidade>>(RequestType.GET, `BuscarDatasPorProcesso/${sqProcesso}`);

	BuscarPorProcessoReferencia = (sqProcesso: number, referencia: string) =>
		this.CreateRequest<ContrachequeEntidade>(RequestType.GET, `BuscarPorProcessoReferencia/${sqProcesso}/${referencia}`);

	BuscarRelatorioContracheque = (sqProcesso: number, referencia: string) =>
		this.CreateRequest<any>(RequestType.GET, `BuscarRelatorioContracheque/${sqProcesso}/${referencia}`, null, ResponseType.Blob);

}

export const FichaFinancAssistidoService = new FichaFinancAssistido();
